var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-card',{staticClass:"main-card d-flex"},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":"","color":"secondary"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }